import Loader from "components/Loader";
import { WYSIWYGText } from "components/WYSIWYGText";
import { useModal } from "hooks/useModal";
import moment from "moment";
import React from "react";
import styled from "styled-components";
import useSWR from "swr";
import { SpaceSubscription } from "../types";
import { SpaceSubscriptionBookingForm } from "./SpaceSubscriptionBookingForm";

interface Props {
    clubSlug: string;
}

export const SpaceSubscriptionsOverview = ({ clubSlug }: Props) => {
    const { data, error } = useSWR<{ data: SpaceSubscription[] }>(`space/subscription/${clubSlug}`);

    return (
        <Loader isLoading={!data && !error}>
            {data?.data?.length > 0 ? (
                data?.data.map((s) => (
                    <div className="mb-3 rounded border" key={s.id}>
                        <SubscriptionPreview subscription={s} />
                    </div>
                ))
            ) : (
                <p className="text-muted">Es sind keine Platzabos verfügbar!</p>
            )}
        </Loader>
    );
};

const StyledSpaceSubscriptionPreview = styled.div`
    padding: 0.75rem;

    cursor: pointer;
    transition: background-color 300ms;
    &:hover {
        background-color: rgba(0, 0, 0, 0.03);
    }
`;

const SubscriptionPreview = ({ subscription }: { subscription: SpaceSubscription }) => {
    const [setModal] = useModal();

    const handleSelectSubscription = () =>
        setModal({
            title: `Abo "${subscription.title}" buchen`,
            content: <SpaceSubscriptionBookingForm subscription={subscription} />,
            show: true,
        });

    return (
        <StyledSpaceSubscriptionPreview onClick={handleSelectSubscription}>
            <h5>{`${moment(subscription.start).format("l")} - ${moment(subscription.end).format("l")}`}</h5>
            <h3>{subscription.title}</h3>
            {subscription.description && <WYSIWYGText>{subscription.description}</WYSIWYGText>}
            {subscription.exemptions?.length > 0 && (
                <>
                    <hr className="mb-2" />
                    <b>Sperrzeiten:</b>
                    {subscription.exemptions.map((e, i) => (
                        <li key={i}>
                            {moment(e.start).format("ll")} - {moment(e.end).format("ll")}
                        </li>
                    ))}
                </>
            )}
            <div className="d-flex justify-content-end">
                <button className="btn btn-success">Zur {subscription.only_requests ? "Anfrage" : "Buchung"}</button>
            </div>
        </StyledSpaceSubscriptionPreview>
    );
};
